import useForm from "hooks/useForm";
import React, { useState } from "react";
import { Button, FormGroup, Input } from "reactstrap";
import API from "api";
import { setPasswordPopup } from "action";
import { useDispatch } from "react-redux";
import useToast from "hooks/useToast";

const SetPassword = ({ toggle }) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [cPasswordVisible, setCPasswordVisible] = useState(false);
  const { makeFormEmpty, onChangeHandler, formData, isFormValid } = useForm({
    password: {
      value: "",
      validation: (value) => value.length >= 8,
      isValid: false,
      error: false,
    },
    cPassword: {
      value: "",
      validation: (value, formData) =>
        !!value && value === formData.password.value,
      isValid: false,
      error: false,
    },
  });

  const handleSubmit = async () => {
    if (!isFormValid) {
      alert("Please enter password");
      return;
    }

    const data = { password: formData.password.value };
    let message = "Something went wrong";
    let type = 2;
    try {
      let response = await API({
        method: "POST",
        url: "set-password",
        data,
      });

      if ((response.status === 200)) {
        console.log("success", response);
        message = "Password updated successfully.";
        type = 1;
        dispatch(setPasswordPopup(false));
      } else {
        message = response?.response?.data?.message || "Something went wrong";
      }
    } catch (error) {
      console.log("error", error);
    }
    showToast({
      message:message,
      type:type,
    });
  };

  return (
    <div className="">
      <h6 className="text-center">Set Password</h6>
      <hr />
      <FormGroup>
        <label htmlFor="password">Password:</label>
        <div className="password-field">
          <Input
            type={passwordVisible ? "text" : "password"}
            className="form-control"
            name="password"
            id="password"
            value={formData.password.value}
            onChange={onChangeHandler}
            onBlur={onChangeHandler}
          />
          <button
            type="button"
            className="password-toggle"
            aria-label={passwordVisible ? "Hide password" : "Show password"}
            aria-pressed={passwordVisible}
            disabled={!formData.password.value}
            onClick={() => setPasswordVisible((prev) => !prev)}
          >
            <i
              className={`fa ${passwordVisible ? "fa-eye-slash" : "fa-eye"}`}
              aria-hidden="true"
            />
          </button>
        </div>
        {formData.password.error && (
          <span className="text-danger">
            The password should be at least 8 characters in length.
          </span>
        )}
      </FormGroup>
      <FormGroup>
        <label htmlFor="confirm-password">Confirm Password:</label>
        <div className="password-field">
          <Input
            type={cPasswordVisible ? "text" : "password"}
            className="form-control"
            name="cPassword"
            id="confirm-password"
            value={formData.cPassword.value}
            onChange={onChangeHandler}
            onBlur={onChangeHandler}
          />
          <button
            type="button"
            className="password-toggle"
            aria-label={cPasswordVisible ? "Hide password" : "Show password"}
            aria-pressed={cPasswordVisible}
            disabled={!formData.cPassword.value}
            onClick={() => setCPasswordVisible((prev) => !prev)}
          >
            <i
              className={`fa ${cPasswordVisible ? "fa-eye-slash" : "fa-eye"}`}
              aria-hidden="true"
            />
          </button>
        </div>
        {formData.cPassword.error && (
          <span className="text-danger">
            The password and confirm password must match.
          </span>
        )}
      </FormGroup>
      <div className="text-center">
        <Button
          className="btn btn-primary"
          disabled={!isFormValid}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default SetPassword;
